import React, { CSSProperties, useContext } from 'react';
import classNames from 'classnames';
import { TranslationsContext } from 'common/hooks/translations-context-provider';
import styles from './index.scss';
import { StoreContext } from '../../store';
import { TranslationsKeys } from '../../translations';

interface Props {
  style?: CSSProperties;
}
export const Icon = ({ style = {} }: Props) => {
  const rootStore = useContext(StoreContext);
  const translate = useContext(TranslationsContext) as (
    path: TranslationsKeys,
    args?: TranslatorMacroReplace
  ) => string;

  const { icon, discover } = rootStore.formatConfig;
  const isLandscape = !rootStore.creativeStore.isVertical;
  const iconStyle: CSSProperties = { height: icon.size };

  let height: string = icon.bannerHeight?.toString() || '';
  if (isLandscape && !discover.show) {
    height = '100%';
  } else {
    if (!discover.show) {
      height = '128px';
    }
  }

  const ctaStyle: CSSProperties = {
    textTransform: icon.uppercase ? 'uppercase' : 'none'
  };

  const containerStyle: CSSProperties = {
    backgroundColor: icon.backgroundColor,
    height,
    ...style
  };

  return (
    <div
      className={classNames(
        styles.container,
        !discover.show ? styles.alignLabelToBottom : ''
      )}
      style={containerStyle}
      data-zone="icon"
    >
      <div className={styles.icon}>
        <img src={icon.url} alt={translate('icon.cta')} style={iconStyle} />
      </div>

      <div className={styles.cta} style={ctaStyle}>
        <div>{translate('icon.cta')}</div>
      </div>
    </div>
  );
};
